import { Injectable } from "@angular/core";
import { StatusCodes } from "@obg/ngx.global";

export abstract class StatusCodeService {
	abstract setStatusCode(statusCode: StatusCodes, description?: string): void;
}

@Injectable()
export class ClientStatusCodeService implements StatusCodeService {
	setStatusCode(_statusCode: StatusCodes, _description?: string): void {
		// noop
	}
}
